jQuery(function($) {
	if (!$('.specials .slider').length)
		return;

	$('.specials .slider').on('init', function(event){
		$('.specials .slider .slick-slide:not(.slick-active)').find('.content_wrapper *:not(object)').attr('tabindex', -1);

		$('.specials .slick-arrow').on('click', function() {
			setTimeout(function(){
				var currentSlideEl = $('.specials .slider .slick-active');
				currentSlideEl.find('.content_wrapper *:not(object)').first().focus();
			}, 100);
		});
	});

	initializeSlick('.specials .slider', {
		accessibility: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		arrows: true,
		autoplay: true,
		fade: true,
		pauseOnFocus: true,
		pauseOnHover: false,
		nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>'
	});

	$('.specials .slider').on('afterChange', function() {
		setTimeout(function(){
			currentSlideEl = $('.specials .slider .slick-active');
			$('.specials .slider .slick-slide').find('.content_wrapper *:not(object)').attr('tabindex', -1);
			currentSlideEl.find('.content_wrapper *:not(object)').attr('tabindex', 0);
		}, 100);
	});
});

jQuery(function($) {
	if (!$('.specials_new').length)
		return;
	$('.specials_new .slider_wrapper .slick-slide').eq(3).addClass('slide_lines');
	$('.specials_new .slide .slide_wrapper').on('focusin', function(){
		$(this).addClass('focusin')
	})
	$('.specials_new .slide .slide_wrapper').on('focusout', function(){
		$(this).removeClass('focusin')
	})
	$('.specials_new .slider_wrapper').on('init', function() {
		$('.specials_new .slick-slide:not(.slick-active)').find('.slide_wrapper, .overlay_content *:not(object)').attr('tabindex', -1);
	});

	$('.specials_new .slider_wrapper').on('init', function(event){
		$('.specials_new .slick-arrow').on('click', function() {
			setTimeout(function(){
				currentSlideEl = $('.specials_new .slider_wrapper .slick-current');
				currentSlideEl.focus();
			}, 300);
		});
	});

	// $('.specials_new .overlay_content:nth-child(3) em').addClass('transparent');

	if (window.matchMedia('(min-width: 1030px)').matches) {	
		$('.specials_new button.glide__arrow.glide__arrow--right').click(function() {
		glide.update({ peek: {before: 150, after: 0} })
		$('.specials_new .row4').addClass('visible')
		$('.specials_new .row1').addClass('visible2')
		$('.specials_new .row4').removeClass('row4')
		$('.specials_new .row1').addClass('row4')
	});
	};

	if (window.matchMedia('(min-width: 1030px)').matches) {	
	$('.specials_new button.glide__arrow.glide__arrow--left').click(function() {
		glide.update({ peek: {before: 0, after: 150} })
		$('.specials_new .visible').addClass('row4')
		$('.specials_new .visible2').removeClass('row4')
	});
	};

	const lastImage = $('.specials_new .ken_burns_wrapper').last()
	const lastSlide = $('.specials_new .glide__slide').last()
	const lastContent = $('.specials_new h3.white_text')
	const transitionImage = lastImage.clone().addClass('transition_image')
	const transitionImageRight = $('.specials_new .ken_burns_wrapper').first().clone().addClass('transition_image right')

	const transitionContainer = $('.specials_new .container')
	const transitionTarget = document.querySelector('.specials_new .container')
	
	transitionContainer.prepend(transitionImage)
	lastSlide.append(transitionImageRight)


	const observer = new IntersectionObserver((entries, observer) => {
		if (entries[0].isIntersecting) {
			observer.unobserve(transitionTarget)
			setTimeout(() => {
				transitionContainer.addClass('transition')
			}, 300)
		}
	})

	observer.observe(transitionTarget)

	const glide = new Glide('.glide', {
		type: 'slider',
		startAt: 0,
		perView: 3,
		dragThreshold: false,
		gap: 0,
		bound: true,
		rewind: false,
		peek: {before: 0, after: 150},
		breakpoints: {
			1105: {
				peek: {before: 0, after: 0},
				perView: 2
			},
			831: {
				peek: {before: 0, after: 0},
				perView: 1
			}}
	})

	glide.mount()

});

